const URL = (process.env.NODE_ENV === 'production')?'https://xqckapi.ddtmx.com/' : 'https://xqckapi.ddtmx.com/';
export default URL;